export const RollCallBreakdetailsreports = [
    {
        "s_no": 1,
        "BioMetric": 1,
        "Employee": "Baji",
        "Dept": "General",
        "Designation": "General",
        "ShiftName": "General Shift",
        "Date": "3/25/2025 12:00:00 AM",
        "Status": "Missed Swipe",
        "InTime": "10:04:55",
        "Out Time": "",
        "Duration": "00:00"
    },
    {
        "s_no": 2,
        "BioMetric": 2,
        "Employee": "ali",
        "Dept": "General",
        "Designation": "General",
        "ShiftName": "General Shift",
        "Date": "3/25/2025 12:00:00 AM",
        "Status": "Missed Swipe",
        "InTime": "10:24:33",
        "OutTime": "",
        "Duration": "00:00"
    },
    {
        "s_no": 3,
        "BioMetric": 3,
        "Employee": "rajesh",
        "Dept": "General",
        "Designation": "General",
        "ShiftName": "General Shift",
        "Date": "3/25/2025 12:00:00 AM",
        "Status": "Missed Swipe",
        "InTime": "10:48:22",
        "OutTime": "",
        "Duration": "00:00"
    },
    {
        "s_no": 4,
        "BioMetric": 4,
        "Employee": "Babji",
        "Dept": "General",
        "Designation": "General",
        "ShiftName": "General Shift",
        "Date": "3/25/2025 12:00:00 AM",
        "Status": "Missed Swipe",
        "InTime": "09:59:14",
        "OutTime": "",
        "Duration": "00:00"
    },
    {
        "s_no": 5,
        "BioMetric": 6,
        "Employee": "Chandu",
        "Dept": "General",
        "Designation": "General",
        "ShiftName": "General Shift",
        "Date": "3/25/2025 12:00:00 AM",
        "Status": "Missed Swipe",
        "InTime": "10:11:28",
        "OutTime": "",
        "Duration": "00:00"
    },
    {
        "s_no": 6,
        "BioMetric": 8,
        "Employee": "Das",
        "Dept": "General",
        "Designation": "General",
        "ShiftName": "General Shift",
        "Date": "3/25/2025 12:00:00 AM",
        "Status": "Missed Swipe",
        "InTime": "10:04:52",
        "OutTime": "",
        "Duration": "00:00"
    },
    {
        "s_no": 7,
        "BioMetric": 12,
        "Employee": "Haleema",
        "Dept": "General",
        "Designation": "General",
        "ShiftName": "General Shift",
        "Date": "3/25/2025 12:00:00 AM",
        "Status": "Missed Swipe",
        "InTime": "10:26:31",
        "OutTime": "",
        "Duration": "00:00"
    }
]
